var _path, _g, _path2, _rect, _rect2, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _rect3, _rect4, _g5, _path8, _path9, _path10, _path11, _path12, _g6, _g7, _path13, _rect5, _rect6, _g8, _path14, _path15, _path16, _path17, _path18, _g9, _g10, _g11, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyEmployees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500.099,
    height: 249.841,
    viewBox: "0 0 500.099 249.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_5461",
    "data-name": "Group 5461",
    transform: "translate(-762.622 -372.913)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M291.683,229.806C350.61,207.93,410.5,227.271,451.122,269.4S576.989,240.32,622.2,282.376c30.854,28.7,16.722,102.493-25.585,134.454-57.5,43.442-232.381,21.4-270.209,14.006-43.582-8.517-75.443-34.359-88.389-65.724C206.825,289.538,265.642,239.474,291.683,229.806Z",
    transform: "translate(585.559 168.471)",
    fill: "#dde4eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5460",
    "data-name": "Group 5460",
    transform: "translate(-68 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(1203.949 364.405)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M2769.066,311.8h-8.511a5.967,5.967,0,0,1-5.96-5.96v-8.511a5.967,5.967,0,0,1,5.96-5.96h8.511a5.967,5.967,0,0,1,5.96,5.96v8.511A5.967,5.967,0,0,1,2769.066,311.8Zm-8.511-18.086a3.619,3.619,0,0,0-3.615,3.615v8.511a3.619,3.619,0,0,0,3.615,3.615h8.511a3.618,3.618,0,0,0,3.614-3.615v-8.511a3.618,3.618,0,0,0-3.614-3.615Z",
    transform: "translate(-2754.595 -291.367)",
    fill: "#bbc6d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    transform: "translate(1163.902 364.405)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M2530.031,311.8h-8.511a5.967,5.967,0,0,1-5.96-5.96v-8.511a5.967,5.967,0,0,1,5.96-5.96h8.511a5.967,5.967,0,0,1,5.96,5.96v8.511A5.967,5.967,0,0,1,2530.031,311.8Zm-8.511-18.086a3.618,3.618,0,0,0-3.614,3.615v8.511a3.618,3.618,0,0,0,3.614,3.615h8.511a3.619,3.619,0,0,0,3.615-3.615v-8.511a3.619,3.619,0,0,0-3.615-3.615Z",
    transform: "translate(-2515.56 -291.367)",
    fill: "#bbc6d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5441",
    "data-name": "Group 5441",
    transform: "translate(1167.527 361.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M2544.32,294.46h-.049a1.006,1.006,0,0,1-.749-.393l-6.117-7.979a1.005,1.005,0,0,1,1.6-1.223l5.394,7.037,14.084-15.09a1.005,1.005,0,0,1,1.47,1.372l-14.895,15.958A1,1,0,0,1,2544.32,294.46Z",
    transform: "translate(-2537.197 -276.491)",
    fill: "#24dcae"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M918.844,1703.293c-38.975-1.7-171.561,1.182-211.885,2.307s-87.13-1.484-111.444-5.321-164.854.326-158.476,10.643,62.617,4.615,126.394,8.761,207.212-.518,239.566,0,62.023-1.036,103.718-3.11S941.436,1704.281,918.844,1703.293Z",
    transform: "translate(325.793 -1098.662)",
    fill: "#dde4eb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3440",
    "data-name": "Rectangle 3440",
    width: 61.661,
    height: 101.065,
    transform: "translate(845.779 419.95)",
    fill: "#536dfe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3441",
    "data-name": "Rectangle 3441",
    width: 56.404,
    height: 95.154,
    transform: "translate(849.01 422.856)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5443",
    "data-name": "Group 5443",
    transform: "translate(865.879 431.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M590.122,684.661c2.123-4.567,5.716-6.03,11.616-6.03,7.025,0,10.673,2.545,11.707,6.251C600.865,685.054,590.122,684.661,590.122,684.661Z",
    transform: "translate(-590.122 -656.214)",
    fill: "#9bd6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M601.005,520.78c-2.974.835-2.844,2.506-3.835,4.057s-3.145,2.585-3.4,3.619.663,3.188-.431,4.395-1.465,1.81-1.034,3.016,1.379,3.1,1.465,3.361a4.829,4.829,0,0,0,2.758,2.327,31.086,31.086,0,0,1,5.6,1.293c1.379.6,5.812-.772,8.273-.686s4.136-1.727,3.964-2.933,1.815-3.619,1.81-5.687c-.005-2.221-2.585-3.878-3.274-5.343s.086-4.05-2.5-5.581c-1.634-.968-2.758-.882-4.05-1.313A9.588,9.588,0,0,0,601.005,520.78Z",
    transform: "translate(-591.842 -520.576)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M658.345,614.657c-.673.993-1.166,1.034-1.9,0-.581-.822-1.723-2.69-1.723-3.638v-9.46a1.728,1.728,0,0,1,1.723-1.723h1.9a1.728,1.728,0,0,1,1.723,1.723v9.46C660.069,611.966,658.949,613.766,658.345,614.657Z",
    transform: "translate(-645.563 -588.594)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M658.345,599.835h-1.9a1.728,1.728,0,0,0-1.723,1.723V610c2.129.677,4.071-.67,5.343-2.187v-6.253A1.728,1.728,0,0,0,658.345,599.835Z",
    transform: "translate(-645.563 -588.594)",
    fill: "#e38540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 5.73,
    cy: 7.808,
    rx: 5.73,
    ry: 7.808,
    transform: "translate(6.104 3.529)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M638.17,538.048c-3.619,6.118-8.962,5.515-8.962,5.515s.129-8.1,4.373-8.531,6.743,1.272,7.6,4.083a6.935,6.935,0,0,1,0,4.663,7.442,7.442,0,0,1-2.068-2.8A20.124,20.124,0,0,1,638.17,538.048Z",
    transform: "translate(-623.664 -532.924)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 1.508,
    cy: 2.262,
    rx: 1.508,
    ry: 2.262,
    transform: "translate(2.996 10.468) rotate(-25.405)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M706.126,590.6c-.536,1.128-.361,2.333.392,2.69s1.8-.268,2.333-1.4.361-2.333-.392-2.69S706.662,589.477,706.126,590.6Z",
    transform: "translate(-689.407 -579.388)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M662.681,630.368a2.481,2.481,0,0,1-4.308,0Z",
    transform: "translate(-648.692 -614.796)",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M623.914,788.116H609.443a1.683,1.683,0,0,1,0-3.365h14.471a1.683,1.683,0,0,1,0,3.365Z",
    transform: "translate(260.621 -315.563)",
    fill: "#536dfe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M610.532,824.568H590.762a1.683,1.683,0,0,1,0-3.365h19.771a1.683,1.683,0,0,1,0,3.365Z",
    transform: "translate(276.654 -346.845)",
    fill: "#536dfe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M543.285,964.21H495.194a.976.976,0,1,1,0-1.953h48.092a.976.976,0,0,1,0,1.953Z",
    transform: "translate(358.061 -467.894)",
    fill: "#dde4eb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M543.285,996.206H495.194a.976.976,0,1,1,0-1.953h48.092a.976.976,0,0,1,0,1.953Z",
    transform: "translate(358.061 -495.352)",
    fill: "#dde4eb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M543.285,1028.2H495.194a.976.976,0,1,1,0-1.953h48.092a.976.976,0,0,1,0,1.953Z",
    transform: "translate(358.061 -522.81)",
    fill: "#dde4eb"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5444",
    "data-name": "Group 5444",
    transform: "translate(858.238 425.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M572.618,514.8H537.978a1.745,1.745,0,0,1-1.743-1.743V481.13a1.745,1.745,0,0,1,1.743-1.743h34.639a1.745,1.745,0,0,1,1.743,1.743v31.925A1.745,1.745,0,0,1,572.618,514.8Zm-34.639-33.993a.329.329,0,0,0-.325.325v31.925a.329.329,0,0,0,.325.325h34.639a.329.329,0,0,0,.325-.325V481.13a.329.329,0,0,0-.325-.325Z",
    transform: "translate(-536.235 -479.387)",
    fill: "#536dfe"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5445",
    "data-name": "Group 5445",
    transform: "translate(861.734 482.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M564.133,875.882l1,2.032,2.242.326-1.623,1.582.383,2.233L564.133,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-560.887 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M622.047,875.882l1,2.032,2.243.326-1.623,1.582.383,2.233L622.047,881l-2.006,1.055.383-2.233L618.8,878.24l2.243-.326Z",
    transform: "translate(-610.587 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M679.961,875.882l1,2.032,2.242.326-1.623,1.582.383,2.233L679.961,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-660.288 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6168",
    "data-name": "Path 6168",
    d: "M737.875,875.882l1,2.032,2.242.326-1.623,1.582.383,2.233L737.875,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-709.988 -875.882)",
    fill: "#fcb151"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3442",
    "data-name": "Rectangle 3442",
    width: 61.661,
    height: 101.065,
    transform: "translate(983.246 419.95)",
    fill: "#536dfe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3443",
    "data-name": "Rectangle 3443",
    width: 56.404,
    height: 95.154,
    transform: "translate(985.629 422.856)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5448",
    "data-name": "Group 5448",
    transform: "translate(1003.346 432.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6169",
    "data-name": "Path 6169",
    d: "M1578.225,596.877c0,4.527,2.726,11.831,9.155,11.6s7.852-7.2,8.1-9.161S1578.225,596.877,1578.225,596.877Z",
    transform: "translate(-1575.546 -586.663)",
    fill: "#7a4e34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6170",
    "data-name": "Path 6170",
    d: "M1559.335,684.661c2.123-4.567,5.716-6.03,11.617-6.03,7.025,0,10.673,2.545,11.708,6.251C1570.078,685.054,1559.335,684.661,1559.335,684.661Z",
    transform: "translate(-1559.335 -656.821)",
    fill: "#d54a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6171",
    "data-name": "Path 6171",
    d: "M1627.56,614.657c-.673.993-1.166,1.034-1.9,0-.58-.822-1.723-2.69-1.723-3.638v-9.46a1.728,1.728,0,0,1,1.723-1.723h1.9a1.728,1.728,0,0,1,1.723,1.723v9.46C1629.283,611.966,1628.162,613.766,1627.56,614.657Z",
    transform: "translate(-1614.777 -589.201)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6172",
    "data-name": "Path 6172",
    d: "M1627.56,599.835h-1.9a1.728,1.728,0,0,0-1.723,1.723V610c2.128.677,4.071-.67,5.342-2.187v-6.253A1.728,1.728,0,0,0,1627.56,599.835Z",
    transform: "translate(-1614.777 -589.201)",
    fill: "#e38540"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 5.73,
    cy: 7.808,
    rx: 5.73,
    ry: 7.808,
    transform: "translate(6.104 2.921)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6173",
    "data-name": "Path 6173",
    d: "M1590.413,529.655c-.681,2.4-2.173,2.373-4.254,3.162s-3.075,1.582-3.756,3.118c-.868,1.959.394,7.67.394,7.67s-5.269-3.943-4.659-10.143,4.265-8.6,7.706-8.6a5.516,5.516,0,0,1,4.749,2.1,5.153,5.153,0,0,1,3.566,2.061c2.33,2.76,1.613,9.462,0,11.863s-2.688,3.154-2.652,3.047,1.505-5.622.717-9.032A21.78,21.78,0,0,0,1590.413,529.655Z",
    transform: "translate(-1575.428 -524.86)",
    fill: "#7a4e34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6174",
    "data-name": "Path 6174",
    d: "M1631.894,630.368a2.481,2.481,0,0,1-4.309,0Z",
    transform: "translate(-1617.905 -615.404)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6175",
    "data-name": "Path 6175",
    d: "M1593.128,788.116h-14.471a1.683,1.683,0,0,1,0-3.365h14.471a1.683,1.683,0,1,1,0,3.365Z",
    transform: "translate(-571.125 -315.563)",
    fill: "#536dfe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6176",
    "data-name": "Path 6176",
    d: "M1579.745,824.568h-19.771a1.683,1.683,0,1,1,0-3.365h19.771a1.683,1.683,0,1,1,0,3.365Z",
    transform: "translate(-555.094 -346.845)",
    fill: "#536dfe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M1512.5,964.21h-48.092a.976.976,0,1,1,0-1.953H1512.5a.976.976,0,1,1,0,1.953Z",
    transform: "translate(-473.688 -467.894)",
    fill: "#dde4eb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M1512.5,996.206h-48.092a.976.976,0,1,1,0-1.953H1512.5a.976.976,0,1,1,0,1.953Z",
    transform: "translate(-473.688 -495.352)",
    fill: "#dde4eb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M1512.5,1028.2h-48.092a.976.976,0,1,1,0-1.953H1512.5a.976.976,0,1,1,0,1.953Z",
    transform: "translate(-473.688 -522.81)",
    fill: "#dde4eb"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5449",
    "data-name": "Group 5449",
    transform: "translate(995.703 425.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M1541.832,514.8h-34.64a1.745,1.745,0,0,1-1.743-1.743V481.13a1.745,1.745,0,0,1,1.743-1.743h34.64a1.745,1.745,0,0,1,1.743,1.743v31.925A1.745,1.745,0,0,1,1541.832,514.8Zm-34.64-33.993a.329.329,0,0,0-.325.325v31.925a.329.329,0,0,0,.325.325h34.64a.329.329,0,0,0,.325-.325V481.13a.329.329,0,0,0-.325-.325Z",
    transform: "translate(-1505.449 -479.387)",
    fill: "#536dfe"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5450",
    "data-name": "Group 5450",
    transform: "translate(999.201 482.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M1533.346,875.882l1,2.032,2.243.326-1.623,1.582.383,2.233L1533.346,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-1530.101 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M1591.261,875.882l1,2.032,2.242.326-1.623,1.582.383,2.233L1591.261,881l-2.006,1.055.383-2.233-1.623-1.582,2.243-.326Z",
    transform: "translate(-1579.801 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M1649.175,875.882l1,2.032,2.243.326-1.623,1.582.383,2.233L1649.175,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-1629.501 -875.882)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M1707.089,875.882l1,2.032,2.243.326-1.622,1.582.383,2.233L1707.089,881l-2.006,1.055.383-2.233-1.623-1.582,2.242-.326Z",
    transform: "translate(-1679.202 -875.882)",
    fill: "#fcb151"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M877.7,539.921h-97.31l6.883-99.679h93.935Z",
    transform: "translate(112.475 -19.917)",
    fill: "#99bbeb",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3444",
    "data-name": "Rectangle 3444",
    width: 84.219,
    height: 138.04,
    transform: "translate(903.088 401.462)",
    fill: "#536dfe"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3445",
    "data-name": "Rectangle 3445",
    width: 77.04,
    height: 129.966,
    transform: "translate(906.652 405.122)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5453",
    "data-name": "Group 5453",
    transform: "translate(929.57 415.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M1095.043,424.248c-.054-.161-1.4-7.9-1.564-10.914s4.839-3.441,4.839-3.441,4.086-2.2,7.043-1.075a11.919,11.919,0,0,1,6.313,5.394c1.344,2.366-1.182,9.738-1.182,9.738Z",
    transform: "translate(-1085.773 -408.497)",
    fill: "#2e2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M1039.168,625.241c-.019-.127.345-3.174.359-3.3.681-6.416,8.589-8.22,16.48-8.22,9.271,0,15.562,1.7,16.565,8.363.029.2.564,3.25.538,3.455C1055.925,625.778,1039.168,625.241,1039.168,625.241Z",
    transform: "translate(-1039.167 -584.616)",
    fill: "#d5e1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M1132.636,526.345c-.919,1.356-1.592,1.412-2.589,0-.793-1.123-3.441-3.685-3.441-4.98l1.087-12.91a2.361,2.361,0,0,1,2.354-2.354h2.589a2.361,2.361,0,0,1,2.354,2.354l.5,12.91C1135.495,522.66,1133.46,525.129,1132.636,526.345Z",
    transform: "translate(-1114.204 -492.258)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6189",
    "data-name": "Path 6189",
    d: "M1133.5,506.1h-2.589a2.361,2.361,0,0,0-2.354,2.354l-.943,11.453c2.907.926,6.833-.956,8.57-3.029l-.329-8.425A2.361,2.361,0,0,0,1133.5,506.1Z",
    transform: "translate(-1115.072 -492.258)",
    fill: "#e38540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6190",
    "data-name": "Path 6190",
    d: "M1097.339,618.86l4.151,7.673s2.222-1.828,2.437-1.469-.394,4.881-.394,4.881a42.543,42.543,0,0,0,5.161-.148c.215-.215-1-4.913-.5-4.913s2.01,1.362,2.01,1.362l4.635-7.386-1.019-.248-7.594,4.086-8.122-4Z",
    transform: "translate(-1089.089 -588.811)",
    fill: "#bdccd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6191",
    "data-name": "Path 6191",
    d: "M1130.81,638.443l3.083,2.069-.955,5.491,4.158-.232-1.039-4.994,2.555-2.333-1.2-1.131h-5.4Z",
    transform: "translate(-1117.812 -604.858)",
    fill: "#d54a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6192",
    "data-name": "Path 6192",
    d: "M1105.051,591.679l-3.813,3.628s3.885,6.909,4.1,6.909,3.3-3.809,3.3-3.809l1.973-.035,3.117,3.27,3.622-6.407-3.694-3.915s-3.154,6.093-3.728,6.236-.578.215-1.041-.143S1105.051,591.679,1105.051,591.679Z",
    transform: "translate(-1092.435 -565.39)",
    fill: "#d5e1e8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 7.827,
    cy: 10.665,
    rx: 7.827,
    ry: 10.665,
    transform: "translate(9.31 3.309)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6193",
    "data-name": "Path 6193",
    d: "M1085.377,493.494c.732,1.541.493,3.186-.535,3.674s-2.454-.366-3.186-1.907-.492-3.187.535-3.675S1084.645,491.952,1085.377,493.494Z",
    transform: "translate(-1075.266 -479.684)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M1204.472,493.494c-.732,1.541-.493,3.186.535,3.674s2.454-.366,3.186-1.907.493-3.187-.535-3.675S1205.2,491.952,1204.472,493.494Z",
    transform: "translate(-1180.662 -479.684)",
    fill: "#f09959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M1142.455,537.875s-1.555,2.518-3.472,2.518-3.472-2.518-3.472-2.518Z",
    transform: "translate(-1121.846 -519.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M1107.8,429.35c3.226-2.258,4.677-1.882,7.1,1.828s5.322,3.775,5.322,3.775l.376-3.847s-3.6-6.971-8.441-6.057-7.589,5.269-7.589,5.269-.236,8.162.439,8.441.753-2.634,1.236-3.226-.484-3.387.161-4.677S1107.8,429.35,1107.8,429.35Z",
    transform: "translate(-1095.257 -422.631)",
    fill: "#2e2d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M1200.773,485.439c1.126,1.233.7,6.129,1.29,6.075s.807-4.677.645-5.161S1200.773,485.439,1200.773,485.439Z",
    transform: "translate(-1177.852 -474.526)",
    fill: "#2e2d3d"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M1051.309,786.006h-35.952a2.3,2.3,0,0,1,0-4.6h35.952a2.3,2.3,0,1,1,0,4.6Z",
    transform: "translate(-87.191 -312.696)",
    fill: "#536dfe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M1073.905,835.794h-27a2.3,2.3,0,1,1,0-4.6h27a2.3,2.3,0,0,1,0,4.6Z",
    transform: "translate(-114.262 -355.422)",
    fill: "#536dfe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M982.057,1026.523H916.371a1.334,1.334,0,0,1,0-2.667h65.686a1.334,1.334,0,1,1,0,2.667Z",
    transform: "translate(-3.072 -520.756)",
    fill: "#dde4eb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M982.057,1070.225H916.371a1.334,1.334,0,0,1,0-2.667h65.686a1.334,1.334,0,1,1,0,2.667Z",
    transform: "translate(-3.072 -558.26)",
    fill: "#dde4eb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M982.057,1113.926H916.371a1.334,1.334,0,0,1,0-2.667h65.686a1.334,1.334,0,1,1,0,2.667Z",
    transform: "translate(-3.072 -595.763)",
    fill: "#dde4eb"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(920.363 409.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M1023.69,414.008H976.378a2.124,2.124,0,0,1-2.121-2.122v-43.6a2.124,2.124,0,0,1,2.121-2.122h47.312a2.124,2.124,0,0,1,2.122,2.122v43.6A2.124,2.124,0,0,1,1023.69,414.008Zm-47.312-46.429a.7.7,0,0,0-.7.7v43.6a.7.7,0,0,0,.7.7h47.312a.7.7,0,0,0,.7-.7v-43.6a.7.7,0,0,0-.7-.7Z",
    transform: "translate(-974.256 -366.16)",
    fill: "#536dfe"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5455",
    "data-name": "Group 5455",
    transform: "translate(919.18 486.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M970.351,905.881l1.37,2.775,3.063.445-2.216,2.16.523,3.051-2.74-1.44-2.74,1.44.523-3.051-2.216-2.16,3.063-.445Z",
    transform: "translate(-965.918 -905.881)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M1049.453,905.881l1.37,2.775,3.063.445-2.216,2.16.523,3.051-2.74-1.44-2.74,1.44.523-3.051-2.216-2.16,3.063-.445Z",
    transform: "translate(-1033.801 -905.881)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M1128.555,905.881l1.37,2.775,3.063.445-2.216,2.16.523,3.051-2.739-1.44-2.74,1.44.523-3.051-2.216-2.16,3.063-.445Z",
    transform: "translate(-1101.684 -905.881)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M1207.657,905.881l1.37,2.775,3.063.445-2.216,2.16.523,3.051-2.74-1.44-2.74,1.44.523-3.051-2.216-2.16,3.063-.445Z",
    transform: "translate(-1169.567 -905.881)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M1288.016,905.881l1.37,2.775,3.063.445-2.216,2.16.523,3.051-2.74-1.44-2.74,1.44.523-3.051-2.216-2.16,3.063-.445Z",
    transform: "translate(-1238.528 -905.881)",
    fill: "#fcb151"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5458",
    "data-name": "Group 5458",
    transform: "translate(-536 154.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(1345.092 417.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M49.4,286.706c0,.005-.565,1.676-1.16,3.773a37.1,37.1,0,0,0-1.359,6.364l1,.075a36.415,36.415,0,0,1,1.323-6.165c.294-1.037.582-1.97.795-2.643s.351-1.084.351-1.084l-.953-.321Z",
    transform: "translate(-35.423 -286.706)",
    fill: "#517073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M39.157,287.673s.02.169.05.478c.091.926.274,3.081.273,5.422,0,1.1-.039,2.233-.147,3.3l1,.1c.111-1.112.152-2.279.152-3.4a57.975,57.975,0,0,0-.331-6.017l-1,.117Z",
    transform: "translate(-34.172 -286.844)",
    fill: "#517073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M33.209,295.5l0,0a3.8,3.8,0,0,1,.43.625,2.57,2.57,0,0,1,.355,1.21H35a3.634,3.634,0,0,0-.529-1.782,4.548,4.548,0,0,0-.525-.738l-.742.68Z",
    transform: "translate(-33.209 -288.02)",
    fill: "#517073"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M48.137,281.039s-5.156-6.54,2.766-20.12,24.269-16.85,25.023-15.09-8.3,5.156-10.814,15.593-2.85,16.221-5.994,19.365S51.7,285.188,48.137,281.039Z",
    transform: "translate(1309.732 137.512)",
    fill: "#24dcae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M38.543,276.055s8.88-9.536-1.418-24.793S4.12,234.94,3.373,237.055,12.26,243.161,16,255.16s5.78,18.013,9.694,21.444S34.7,281.177,38.543,276.055Z",
    transform: "translate(1316.721 138.995)",
    fill: "#24dcae",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M28.207,287.056s-.566-7.354-13.878-11.447S-11.6,279.2-11.031,280.8s8.5-1.623,16.4,3.667,11.593,8.858,15.528,9.019S28.376,291.9,28.207,287.056Z",
    transform: "translate(1319.049 132.811)",
    fill: "#63e8c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(1359.461 387.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M50.86,279.984a.5.5,0,0,1-.485-.638c.23-.83,5.753-20.428,15.966-27.914a.5.5,0,0,1,.594.812C57,259.522,51.4,279.415,51.344,279.615A.5.5,0,0,1,50.86,279.984Z",
    transform: "translate(-50.356 -251.334)",
    fill: "#f9fbfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(1326.893 377.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M34.281,275.5a.552.552,0,0,1-.5-.375,2.253,2.253,0,0,1-.059-.546c-.461-6.893-3.4-29.76-21.849-34.588a.5.5,0,1,1,.255-.973c19.1,5,22.125,28.431,22.6,35.494.013.19.02.313.027.363a.473.473,0,0,1-.327.6A.481.481,0,0,1,34.281,275.5Z",
    transform: "translate(-11.494 -239.006)",
    fill: "#f9fbfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(1318.033 410.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M26.355,291.074c-.228,0-.453-.2-1.187-.868-8.274-7.488-16.249-11.033-23.71-10.55a.5.5,0,0,1-.065-1c7.745-.515,15.966,3.13,24.45,10.808.294.267.6.541.715.631a.5.5,0,0,1-.018.948A.576.576,0,0,1,26.355,291.074Z",
    transform: "translate(-0.923 -278.604)",
    fill: "#f9fbfc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M49.31,328.26H23.373a1.4,1.4,0,0,1-1.366-1.086l-6.394-27.626a1.4,1.4,0,0,1,1.366-1.718H55.7a1.4,1.4,0,0,1,1.366,1.718l-6.393,27.626A1.4,1.4,0,0,1,49.31,328.26Z",
    transform: "translate(1314.738 129.021)",
    fill: "#c7d3db"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459",
    transform: "translate(-533.545 77.702)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M426.859,326.815c.326.917-6.1,12.132-7.2,13.033-1.088.9-9.876,1.555-10.109.218-.218-1.322,4.992-4.2,4.992-4.2l.981-5.77,6.018-7.388A64.569,64.569,0,0,1,426.859,326.815Z",
    transform: "translate(1334.95 186.081)",
    fill: "#758ca1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M374.351,332.024c1.867,3.842,3.018,6.423,2.816,6.749-.871,1.463-23.764,3.8-24.153,1.323-.39-2.489,11.275-7.248,11.275-7.248A14.843,14.843,0,0,0,374.351,332.024Z",
    transform: "translate(1318.23 188.835)",
    fill: "#758ca1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M323.541,258.32a50.035,50.035,0,1,1,2.349-7.652l-1.228,4.557C324.319,256.267,323.961,257.308,323.541,258.32Zm-7.433-18.556a39.59,39.59,0,1,0-39.582,39.6A39.587,39.587,0,0,0,316.107,239.765Z",
    transform: "translate(1280.668 146.608)",
    fill: "#bbc6d1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M351.31,245.043l6.127,1.228.311.062,2.893.591-1.509,9.347-3.25-.653-31.277-6.267c-.857-.342-1.836-.919-2.023-1.774-.28-1.353-3.811-2.395-5.288-2.674a2.806,2.806,0,0,0-.5-.078c-.777-.047-2.427.575-1.259,2.721l-14.263-2.923c.42-1.012.779-2.054,1.121-3.1.42-1.322.793-2.676,1.1-4.028.047-.171.078-.358.124-.529l.389-1.43,32.8,6.594h.016Z",
    transform: "translate(1302.935 160.305)",
    fill: "#bbc6d1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M375.577,287.93s15.662-8.274,19.551-18.492c-3.531,14.573-18.68,30.172-18.68,30.172-.575-6.345-.855-11.633-.855-11.633Z",
    transform: "translate(1324.907 170.329)",
    fill: "#13258d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M456.646,263.333l-3.686,15.74-44.59-9.658-3.375-.731-39.722-8.6-19.535-4.23.249-1.587.141.031,1.4-9.378h-.031l.389-2.457c.078-.047.14-.093.218-.14l9.565,1.85,37.3,7.217,3.98.777,29.131,5.63.078.016.513.109c1.135.28,3.344.98,4.324,2.691,1.369,2.332-1.368,7.7-.062,7.387,6.844-1.6,6.486-6.438,6.222-8.055Z",
    transform: "translate(1316.083 162.31)",
    fill: "#758ca1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M431.385,339l-6.019,7.388-.779.544c-.871.2-41.712-21.183-44.715-26.145-1.695-2.785-2.892-12.567-3.624-20.639,0,0,15.149-15.6,18.68-30.172a13.2,13.2,0,0,0,.684-2.365v.109c2.037,23.422-3.686,34.015-.575,41.013C397.433,314.133,420.7,331.1,431.385,339Z",
    transform: "translate(1325.104 169.789)",
    fill: "#3b55eb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M420.386,257.594c.264,1.617.622,6.454-6.222,8.055-1.306.311,1.432-5.055.062-7.387-.979-1.712-3.189-2.411-4.324-2.691l-.513-.109-.078-.016c-.078-.031-.124-.031-.124-.047,0-.078,1.306-1.726,1.306-1.726l1.276-.7,4.852-2.69.047-.016c2.177,4.137,3.624,6.92,3.624,6.92S420.324,257.328,420.386,257.594Z",
    transform: "translate(1334.844 164.66)",
    fill: "#f8e8ab"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M434.1,260.118l-.047.016-4.852,2.69s-19.318-26.922-22.381-28.9c-3.08-1.976-29.458-7.559-31.651-5.474-1.368,1.306,9.129,15.8,18.462,30.437l-37.3-7.217c-1.306-3-2.41-5.723-3.1-7.87-.42-1.446-.824-2.908-1.2-4.4-1.461-6.019-2.317-12.318-1.415-17.886,0,0,1.648.824,9.814-4.091a41.162,41.162,0,0,1,11.4-.124c6.874.84,38.182,5.257,41.93,8.041C416.521,227.378,428.091,248.8,434.1,260.118Z",
    transform: "translate(1317.417 154.81)",
    fill: "#536dfe"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M423.539,260.3l-1.276.7s-15.179-20.872-20.731-24.574-18.181-6.7-28-7.186c0,0,10.048,14.216,18.414,27.9l-3.98-.777c-9.333-14.636-19.831-29.131-18.462-30.437,2.194-2.085,28.572,3.5,31.651,5.474C404.221,233.383,423.539,260.3,423.539,260.3Z",
    transform: "translate(1323.075 157.329)",
    fill: "#3b55eb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M396.556,269.169l-2.4-.047a46.98,46.98,0,0,0-2.69-6.454l3.375.731A18.226,18.226,0,0,1,396.556,269.169Z",
    transform: "translate(1329.605 168.327)",
    fill: "#3b55eb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M403.225,271.085l-3.047-.047-27.872-.513-2.892-.047-1.12-.015s-3.5-6.5-7.481-14.433l39.722,8.6A46.98,46.98,0,0,1,403.225,271.085Z",
    transform: "translate(1320.541 166.364)",
    fill: "#536dfe"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M378.37,267.228l27.872.513a13.192,13.192,0,0,1-.684,2.365c-3.888,10.218-19.551,18.492-19.551,18.492-6.8,3.686-26.673,14.713-27.871,18.415-1.135,3.469,13.609,31.122,19.969,44.186a14.844,14.844,0,0,1-10.062.824s-27.093-37.591-27.731-47.561c-.637-9.72,33.314-35.849,35.165-37.28Z",
    transform: "translate(1314.476 169.661)",
    fill: "#3b55eb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M356.961,213.232a29.867,29.867,0,0,1,2.954,3.033,4.52,4.52,0,0,0,.171.591c1.043,2.722,1.7,4.137,2.722,4.137-8.165,4.915-9.814,4.091-9.814,4.091l-.093.14s.093-1.99-2.194-5.3c-.047.016-4.713.637-5.443.3-.7-.327-2.753-8.9-3.033-14.6.53-.109,6.237-1.338,7.388-.327,1.2,1.073.746,5.35,2.271,5.086,1.524-.249.513-1.976.871-2.3a2.017,2.017,0,0,1,2.5,1.525,5.791,5.791,0,0,1,.187,2.3l.155.031s.156.155.421.4c.124.124.28.264.435.42C356.618,212.89,356.79,213.046,356.961,213.232Z",
    transform: "translate(1315.044 151.241)",
    fill: "#f8e8ab"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M359.438,202.24c1.883,4.137.342,12.3,1,15.552a29.883,29.883,0,0,0-2.954-3.033c-.171-.187-.342-.342-.5-.482-.171-.171-.311-.311-.435-.42-.266-.249-.421-.4-.421-.4l-.156-.031a5.789,5.789,0,0,0-.187-2.3,2.017,2.017,0,0,0-2.5-1.525c-.358.327.653,2.054-.871,2.3-1.525.264-1.074-4.013-2.271-5.086-1.151-1.012-6.858.218-7.388.326a.048.048,0,0,1-.031.016s-1.8-.871-2.239-3.935c0,0,5.226-1.166,8.072-2.007S357.432,197.839,359.438,202.24Z",
    transform: "translate(1314.529 149.714)",
    fill: "#758ca1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M355.1,234.279c.373,1.494.777,2.955,1.2,4.4a26.458,26.458,0,0,1-6.469,6.02l-.187-.031-.031.171a28.388,28.388,0,0,1-3.282,1.866l-.311-.062-6.127-1.228C346.982,242.973,355.1,234.279,355.1,234.279Z",
    transform: "translate(1314.353 159.932)",
    fill: "#3b55eb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M356.9,220.615l.093-.14c-.9,5.568-.047,11.867,1.415,17.886,0,0-8.119,8.694-15.21,11.137l-14.481-2.909c5.165-.933,11.665-2.427,14.077-4.495C346.975,238.5,353.491,229.356,356.9,220.615Z",
    transform: "translate(1311.049 155.85)",
    fill: "#536dfe"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M321.443,247.232a8.448,8.448,0,0,0,1.322.4s-6.642,2.394-9.425-.84a7.294,7.294,0,0,1-.964-1.37c-1.168-2.146.482-2.768,1.259-2.721a2.8,2.8,0,0,1,.5.078c1.477.28,5.008,1.322,5.288,2.674C319.607,246.314,320.586,246.89,321.443,247.232Z",
    transform: "translate(1306.097 162.423)",
    fill: "#f8e8ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M310.338,236.658a36.928,36.928,0,1,0-36.921,36.937A36.925,36.925,0,0,0,310.338,236.658Z",
    transform: "translate(1283.78 149.714)",
    fill: "#a5b7c6",
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEmployees);
export default __webpack_public_path__ + "static/media/empty-employees.e42f2c65.svg";
export { ForwardRef as ReactComponent };